import type { RouteObject } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { RequireAuth } from "@/components/RequireAuth";
import { Home } from "@/pages/Home";
import { CyclesList } from "@/pages/CyclesList";
import { CyclesNew } from "@/pages/CyclesNew";
import { CycleReview } from "@/pages/CycleReview";
import { Skus } from "@/pages/Skus";
import { Login } from "@/pages/Login";

export const routes: RouteObject[] = [
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: "cycles", element: <CyclesList /> },
      { path: "cycles/new", element: <CyclesNew /> },
      { path: "cycles/:cycleId/review", element: <CycleReview /> },
      { path: "skus", element: <Skus /> },
    ],
  },
];
